/** @format */

import { buildDocumentDownloadParams } from 'src/analytics/buildGa4EventPayload';
import { trackGa4 } from 'src/analytics/trackGa4';
import type { Ga4DocumentDownloadParams } from 'src/analytics/ga4Parameters';
import type { TrackGa4Options } from 'src/analytics/trackGa4';

export const GA4_DOCUMENT_CATEGORY = Object.freeze({
  EXTRANET: 'extranet',
  CONTENT_EDITOR: 'content_editor'
});

export function trackDocumentDownload(
  params: Ga4DocumentDownloadParams & { url?: string; file_name?: string } = {},
  options: TrackGa4Options = {}
): void {
  trackGa4('document_download', buildDocumentDownloadParams(params), options);
}
